import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';

export interface DialogData {
  errors: string[];
}

@Component({
  selector: 'code-system-version-violation-dialog',
  templateUrl: 'code-system-version-violation-dialog.component.html',
})

export class CodeSystemVersionViolationDialogComponent {

  dataSource = new MatTableDataSource<string>();
  displayedColumns = ['index', 'errorMessage'];

  constructor( @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.dataSource.data = data.errors;
  }
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/components/code-system-version-violation-dialog.component.ts